import * as React from 'react';
import EmailIcon from '../../../../../ui/icons/Email/Email';
import { NotificationPreferences } from '../../../../../../../../__generated__/loma';
import { useTranslations } from '../../../../../../hooks/useTranslations';
import { LayoutTree } from '../../../../DynamicLayout';
import EmailOptInForm from './EmailOptInForm';
import { Channels } from '../../../types';
import OptInTemplate from '../OptInTemplate';

export interface OptInProps {
  onOptIn: (
    contactInfo: string,
    retailerLevel: boolean,
    marketingOptInChecked?: boolean,
    savePreferencesChecked?: boolean,
  ) => void;
  featureName?: string;
  layout?: LayoutTree.FeatureLayout;
  channel: Channels;
  validationError?: boolean;
  notificationPreferencesState?: NotificationPreferences;
}

export interface OptInChannelProps {
  optInChannelInput: React.ReactNode;
  optInIcon: React.ReactNode;
  optInMessageText: string;
}

const OptIn = ({
  featureName,
  layout,
  onOptIn,
  channel,
  validationError,
  notificationPreferencesState,
}: OptInProps) => {
  const { notificationCenterEmailOptinMessage } = useTranslations();

  const emailOptInChannelProps: OptInChannelProps = {
    optInChannelInput: (
      <EmailOptInForm
        onOptIn={onOptIn}
        validationError={validationError}
        layout={layout}
        featureName={featureName}
        notificationPreferencesState={notificationPreferencesState}
      />
    ),
    optInIcon: <EmailIcon />,
    optInMessageText: notificationCenterEmailOptinMessage || '',
  };

  return (
    <OptInTemplate
      featureName={featureName}
      layout={layout}
      channel={channel}
      optInChannelProps={emailOptInChannelProps}
    />
  );
};

export default OptIn;
